<template>
  <div class="loginWrap">
    <div class="login-content">
      <div class="login-img">
        <img class="login-imgs" src="../../public/static/images/login.png">
      </div>
      <div class="login-bg">
        <div class="login-bg-title">
          欢迎登录
        </div>
        <div class="login-input-call">
          <div class="login-input-item">
            <div class="login-input-label">
              <i class="icon etv etv-account"></i>
            </div>
            <van-field :clearBtn="false" v-model="userName" placeholder="请输入账号"/>
          </div>
          <div class="login-input-item">
            <div class="login-input-label">
              <i class="etv icon etv-password"></i>
            </div>
            <van-field v-model="userPwss" :clearable="false" placeholder="请输入密码"
                       type="password" :show-password="true" />

          </div>
        </div>
      </div>
      <div class="login-btn">
        <nut-button block class="landing" @click="login">
          登录
        </nut-button>
      </div>
      <div class="login-btn" style="font-size: 12px;display: flex;justify-content: flex-end">
        <!--<span @click="goto">注册</span>-->
        <span>当前版本：4.1.7-241121</span>
      </div>
      <!--      <a class="aq" href="https://beian.miit.gov.cn">
              粤ICP备18130949号-3
            </a>
            <van-popup v-model="show">
              <div class="content-module">
                <div>关于网络安全的通知</div>
                <p>依据监管要求，您使用的“ETV”登录密码不得使用类似于admin这种简单密码(比如: 11111 aaaa,
                  123456, abcdef, 123123,abcabc,' +
                  ' abc123、123456、12345678、 admin, root
                  等等)，请务必立即修改为强密码(密码长度至少有12个字符，至少包含以下四类字符中的三类:字母、数字，以及特殊符号(如!.@.#))。</p>
                <p>
                  请务必通知贵司相关人员和贵司客户立即整改，如问题已修复或不存在，请告知我们问题已解决!届时不整改者造成的安全性问题、经济损失和法律风险责任自负!
                </p>
                <div style="height: 15px"></div>
                <van-button type="primary" size="small" block @click="show = false">知道了</van-button>
              </div>
            </van-popup>-->
    </div>
    <div class="isPassVerify" v-if="isPassVerify">
      <div class="passVerify">
        <div class="passVerify-title">短信验证</div>
        <div class="passVerify-explain">为了您的账号安全，请进行身份验证</div>
        <div v-if="type === 1" class="passVerify-email">{{ this.passBind }}</div>
        <div v-if="type === 0" class="passVerify-phone">{{ this.passBind }}</div>
        <div class="passVerify-code">
          <input type="number" v-model="uuidCode">
          <van-button :disabled="getCodeing" type="button" class="getCode" @click="getUuidCode()">{{
              uuidCodeText
            }}
          </van-button>
        </div>
        <div class="passVerify-btn">
          <div class="passVerify-opt">
            <el-button v-if="type===1"
                       v-show="showButton"
                       style="
            color: #00a2fe;
            border: none;
            background-color:transparent;"
                       @click="selectedOption(0)">
              手机号
            </el-button>
            <el-button v-if="type===0"
                       v-show="showButton"
                       style="
            color: #00a2fe;
            border: none;
            background-color:transparent;"
                       @click="selectedOption(1)">
              邮箱
            </el-button>
          </div>
          <el-button class="control-btn" size="mini" @click="isPassVerify = false">取消</el-button>
          <el-button class="control-btn" size="mini" type="danger" @click="uuidLogin">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import qs from 'qs'
import { Toast } from 'vant'

function decode(data) {
  try {
    var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
    key = CryptoJS.enc.Hex.parse(key)
    let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
    /*    console.log(key);
        console.log(iv);*/

    var dec = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(data.data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    })

    return JSON.parse(CryptoJS.enc.Utf8.stringify(dec))
  } catch (e) {
    console.warn(e)
  }
  return ''

}
function encrypt(data) {
  var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
  key = CryptoJS.enc.Hex.parse(key)
  let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
  var enc = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  var enced = enc.ciphertext.toString()
  return enced
}
export default {
  name: 'Login',
  data() {
    return {
      userName: '',
      userPwss: '',
      topTitle: '登入',
      show: true,
      isPassVerify: false,
      passBindPhone: "131****3215",
      uuid: "",
      uuidCode: "",
      uuidCodeText: "验证码",
      getCodeing: false,
      getPass: {
        userPhoneRetrieve: '',
        userPassRetrieve: '',
        userPassNewRetrieve: '',
        codeNumberRetrieve: '',
      },
      loading: false,
      platformType:1,
      type: 1,
      showButton: true,
      passBind: '',
    }
  },
  mounted() {
    document.title = '登陆'
    window.onresize = () => {
      return (() => {
        this.handleLableWidth()
      })()
    }
    this.handleLableWidth()
  },
  methods: {
    getUuidCode() {
      if (this.getCodeing) {
        return
      }
      this.getCodeing = true
      let i = 60
      this.uuidCodeText = `${i}后重新获取`
      let timer = setInterval(() => {
        i--
        this.uuidCodeText = `${i}后重新获取`
        if (i === 0) {
          this.getCodeing = false
          timer && clearInterval(timer)
          this.uuidCodeText = `验证码`
        }
      }, 1000)
      this.$ajax.post("/etv/getSecondConfirmSmsCode.json", qs.stringify({
        uuid: this.uuid,
        type:this.type
      })).then(res => {
        if (res.data.code === 0) {
          Toast(res.data.msg,'fail')

        }else {
          Toast(res.data.msg,'fail')
        }
      })
    },
    getInifData() {
      this.$ajax.post('/etv/getUploadServer.json').then(res => {
        if (res.data.code === 0) {
          localStorage.setItem("upFileUrl", res.data.data)
          // localStorage.setItem('upFileUrl', 'https://www.ysetv.cn/')
          this.$router.push('/terminal')
        }
      })
    },
    handleLableWidth() {
      if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
        window.setTimeout(function () {
          document.activeElement.scrollIntoViewIfNeeded()
        }, 0)
      }
    },
    login() {
      this.$ajax.post('/etv/login.htm', qs.stringify({
        'username': encrypt(this.userName),
        'password': encrypt(this.userPwss),
        'platformType':1
        /*'platformType':encrypt(this.platformType),*/
      })).then(res => {
        let code = res.data.code
        //1邮箱2手机3都有
        //this.verifyFlag =res.data.verifyFlag
        this.passBind = res.data.email
        this.email = res.data.email
        let passBindPhone=res.data.phone
        /*let msg = res.data.msg*/
        if (code === 0) {
          let data = decode(res.data)
          Toast(res.data.msg,'success')
          localStorage.setItem('token', data.token)
          localStorage.setItem('userId', data.id)
          localStorage.setItem('username', data.username)
          localStorage.setItem('isSafePwd', data.isSafePwd)
          if(!data.isSafePwd){
            this.$router.replace("/editPass")
            return
          }
          this.getInifData()
        } else if(res.data.code===6001){
          this.isPassVerify = true
          this.passBindPhone = res.data.phone
          this.uuid = res.data.uuid
          this.email=res.data.email
          if (this.email === '') {
            this.type=0
            if(passBindPhone.length>10){
              this.showButton = false
              this.passBind = this.passBindPhone
            }else {
              this.isPassVerify = false
              Toast('您获取的验证码的手机号格式有误，请联系管理员修改！','fail')
            }
          } else if (this.passBindPhone === '') {
            this.type=1
            if(this.email.includes('@')){
              this.showButton = false
              this.passBind = this.email
            }else {
              this.isPassVerify = false
              Toast('您获取的验证码的邮箱格式有误，请联系管理员修改！','fail')
            }
          }
        }else {
          Toast(res.data.msg,'fail')
        }
        this.loading = false
      })
    },
    goto() {
      this.$router.push('/Register')
    },
    uuidLogin() {
      this.$ajax.post("/etv/smsCodeConfirmLogin.json", qs.stringify({
        uuid: this.uuid,
        smsCode: this.uuidCode,
        type: this.type
      })).then(res => {
        if (res.data.code === 0) {
          let data = decode(res.data)
          localStorage.setItem('token', data.token)
          localStorage.setItem('userId', data.id)
          localStorage.setItem('username', data.username)
          localStorage.setItem('isSafePwd', data.isSafePwd)
          if(!data.isSafePwd){
            this.$router.replace("/editPass")
            return
          }
          this.getInifData()

        } else {
          //Toast(res.data.msg)
          Toast(res.data.msg,'fail')
        }
      })
    },
    selectedOption(option) {
      this.type = option
      //let verifyFlag= this.verifyFlag
      this.showButton = true
      if (this.type === 0) {
        this.passBind = this.passBindPhone
      } else {
        this.passBind = this.email
      }
    },
  },

}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.van-popup--center {
  width: 90%;
  border-radius: 10px;
  .content-module {
    width: 100%;
    height: auto;
    margin: 0 auto;
    padding: 10px 10px 20px 10px;
    box-sizing: border-box;


    div {
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }

    p {
      margin-bottom: 10px;
      text-indent: 2em;
      line-height: 1.5;
    }
  }
}


.loginWrap {
  height: 100%;
  overflow-y: auto;
}

.topTitle {
  height: 40px;
  background: #1B89FA;
  line-height: 40px;
  text-align: center;
  color: #fff;
}

.login-content {
  position: relative;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100%;
  padding-bottom: 35px;

  .login-img {
    margin-top: 30px;
    padding: 0 20px;
    margin-bottom: 20px;

    .login-imgs {
      width: 100%;

    }
  }

  .login-bg {
    padding: 8px 40px;
    box-sizing: border-box;

    .login-bg-title {
      font-size: 22px;
      font-weight: 700;
      color: $uni-text-color;
      margin-bottom: 25px;
    }

    .login-input-call {
      .login-input-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        border-bottom: 1px solid $uni-border-bottom-color;
        .van-field{
          background: none;
        }
        .login-input-label {
          color: $uni-border-bottom-color;
          margin-right: 10px;

          i {
            font-size: 24px;
          }
        }

        .nut-textinput {
          flex: 1;

          input {
            background: none;
          }
        }

        input {
          border-radius: 0;
          border: none;
        }

      }

      .login-input-item:nth-of-type(2) {
        margin-bottom: 10px;
      }

      .editServe {
        height: 20px;
        line-height: 20px;
        text-align: right;
        color: #999;
        font-size: 12px;
      }

    }
  }

  .login-btn {
    padding: 0 40px;
    margin-top: 15px;

    .landing {
      border-radius: 3px;
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 3px;
      color: $uni-text-color-inverse;
      background: $uni-color-primary;
    }
  }

  .aq {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background: #2c3e50;
    color: white;
    font-size: 14px;
    display: inline-block;
    text-decoration: none;
  }

}
.isPassVerify {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  display: flex;
  justify-content: center;
  align-items: center;


  .passVerify {
    position: absolute;
    background: #ffffff;
    border-radius: 5px;
    width: 90%;
    margin: 10px;
    padding: 10px;
    .passVerify-phone {
      height: 30px;
      font-size: 16px;
    }

    .passVerify-email {
      height: 30px;
      font-size: 16px;
    }
    .passVerify-btn{
      padding: 30px 0px 0px 0px; /* 调整按钮的内边距 */
      font-size: 12px;
      display: flex;
      align-items: center;
      .control-btn {
        padding: 5px 10px; /* 调整按钮的内边距 */
        margin-left: 17px;
        color: $uni-text-color-inverse;
        background: $uni-color-primary;
        justify-content: flex-end;
        border: none;
      }
      .passVerify-opt {
        flex: 1;
      }
    }
    .passVerify-title {
      height: 30px;
      font-weight: bold;
    }
    .passVerify-phone {
      height: 30px;
      font-size: 16px;
    }
    .passVerify-code {
      height: 30px;
      font-size: 12px;
      display: flex;
      border: 1px solid #cccccc;
      margin-top: 20px;
      align-items: center;
      border-radius: 6px;
      overflow: hidden;
      input {
        border: none;
        outline: none;
        height: 28px;
        flex: 1;

      }
      .getCode {
        width: 80px;
        cursor: pointer;
        height: 100%;
        font-size: 12px;
        border: none;
        padding: 0px;
        line-height: 1px;
        color: $uni-text-color-inverse;
        background: $uni-color-primary;
      }
    }
    .passVerify-explain {
      height: 30px;
      font-size: 12px;
      margin-top: 10px;
    }

  }


}



</style>
